// removed by extract-text-webpack-plugin
module.exports = {"list":"list___20Zv1","toggle":"toggle___3HZsQ","text":"text___2xv08","item":"item___3gEfz","dropActive":"dropActive___85kYK","disabled":"disabled___yAYdY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BoxList/index.scss
// module id = 73
// module chunks = 0